// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PrivateBenchmarkPerformanceDataFromJSON, PrivateBenchmarkPerformanceDataToJSON, } from './';
export function PrivateBenchmarkDataFromJSON(json) {
    return {
        'referenceDate': new Date(json['referenceDate']),
        'numberOfFunds': !exists(json, 'numberOfFunds') ? undefined : json['numberOfFunds'],
        'irr': !exists(json, 'irr') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['irr']),
        'tvpi': !exists(json, 'tvpi') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['tvpi']),
        'picc': !exists(json, 'picc') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['picc']),
        'dpi': !exists(json, 'dpi') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['dpi']),
        'dcc': !exists(json, 'dcc') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['dcc']),
        'rvpi': !exists(json, 'rvpi') ? undefined : PrivateBenchmarkPerformanceDataFromJSON(json['rvpi']),
    };
}
export function PrivateBenchmarkDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'referenceDate': value.referenceDate.toISOString(),
        'numberOfFunds': value.numberOfFunds,
        'irr': PrivateBenchmarkPerformanceDataToJSON(value.irr),
        'tvpi': PrivateBenchmarkPerformanceDataToJSON(value.tvpi),
        'picc': PrivateBenchmarkPerformanceDataToJSON(value.picc),
        'dpi': PrivateBenchmarkPerformanceDataToJSON(value.dpi),
        'dcc': PrivateBenchmarkPerformanceDataToJSON(value.dcc),
        'rvpi': PrivateBenchmarkPerformanceDataToJSON(value.rvpi),
    };
}
